import { createContext, useContext } from "react";
import type { ReactNode } from "react";

interface MenuContextValue {
  isInMenu: boolean;
  closeMenu: () => void;
  /** Render a dialog at the Menu root level so it survives menu close */
  showDialog: (element: ReactNode) => void;
}

const MenuContext = createContext<MenuContextValue>({
  isInMenu: false,
  closeMenu: () => {},
  showDialog: () => {},
});

export const MenuProvider = MenuContext.Provider;
export const useIsInMenu = () => useContext(MenuContext).isInMenu;
export const useCloseMenu = () => useContext(MenuContext).closeMenu;
export const useShowMenuDialog = () => useContext(MenuContext).showDialog;
